var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[_c('button',{staticClass:"refreshButton",on:{"click":function($event){return _vm.onClick()}}},[_c('i',{staticClass:"icon_refresh"})])])}
var staticRenderFns = []

export { render, staticRenderFns }